// extracted by mini-css-extract-plugin
export default {"announcements":"bc_QK p-2","announcement":"bc_QL card my-2","announcement--highlighted":"bc_QM","announcement__list-item":"bc_QN py-1","announcement__flag":"bc_QP"};